import { createContext } from 'react';

export interface IClient {
  id: number;
  name: string;
}

export interface FolderPathItem {
  id: string;
  name: string;
}

export type IVaultContext = {
  setHeaderTitle: (title: string[]) => void;
  headerTitle: string[];
  client?: IClient;
  setClient?: (client?: IClient) => void;
  folderPath: FolderPathItem[];
  setFolderPath: (folderPath: FolderPathItem[]) => void;
  wealthAccountId?: number;
};

export const VaultContext = createContext<IVaultContext>(
  {} as unknown as IVaultContext,
);
